import type { IdentityRepository } from '../../domain/identity/repository';
import type { IdentityUser } from '../../domain/identity/model';
import { bootstrapUser } from '../../services/users';
import {
  subscribeToUserRoles,
  type AuthUser,
} from './auth';

/** Platform adapter for identity bootstrap and live role changes. */
export function createIdentityRepository(): IdentityRepository {
  return {
    bootstrapUser(user: IdentityUser) {
      // The compatibility service still performs the persisted bootstrap and
      // Aligned linkage. The adapter keeps its Firebase user value contained.
      return bootstrapUser(user as AuthUser);
    },
    subscribeRoles: subscribeToUserRoles,
  };
}
